<template>
  <Card dis-hover shadow>
    <div slot="title">
      <Button type="primary" to="list">
        <b>返回</b>
      </Button>
    </div>
    <h2 class="text-center mb-2">新增站点</h2>
    <table-user-basic ref="userBasic"></table-user-basic>
    <Row type="flex" justify="center" align="middle" class="mt-4">
      <Button type="error" @click="clickpost">新增</Button>
    </Row>
  </Card>
</template>
<script>
import { mapGetters } from 'vuex';
import TableUserBasic from './components/TableUserBasic'
export default {
  components: {
    TableUserBasic
  },
  computed: {
    ...mapGetters(['getmember'])
  },
  methods: {
    async clickpost () {
      const form = this.$refs.userBasic.form
      if (form.upass == form.chpassword && form.upadd != '') {
        try {
          const data = { loid: this.getmember.pid, ...form }
          const res = await this.$axios.acount.adduser(data)
          if (res.status == '1') {
            this.$Message.success('成功');
            this.$router.push({ name: 'list' })
          }
        } catch (err) {
          console.error(err);
          this.$Message.error('请将栏位填写完整');
        }
      } else {
        this.$Message.error("密码与密码确认不相符")
      }
    }
  }
};
</script>